<!-- Embed into site -->
<div class="py-3" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
  <span class="heading-regular">Embed into your site</span>
  <div class="heading-bold px-3" fxFlexOffset="15px">
    Directly embed the active form onto your site. This way it will appear in the middle of your webpage.
  </div>
  <span class="body-1-regular-2 px-3" fxFlexOffset="15px">How to embed the form</span>


  <div class="stepper pt-3" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="20px">
    <div class="step" fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="10px">
      <div class="dot">1.</div>
      <div class="label">Identify the webpage where you want to add your form</div>
    </div>
    <div class="line"></div>
    <div class="step" fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="10px">
      <div class="dot">2.</div>
      <div class="label">Style and copy your active form source code</div>
    </div>
    <div class="line"></div>
    <div class="step" fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="10px">
      <div class="dot">3.</div>
      <div class="label">Add the HTML source code to your webpage</div>
    </div>
  </div>
</div>

<div class="fx-col-w-100 fx-gap-10">
  <span class="heading-regular">Embeddable source code</span>

  <button (click)="copyEmbedCode()" class="button-primary fx-center" style="width: 200px" mat-button>
    <div class="button-text">Copy code</div>
  </button>
</div>

<!-- QR code form -->
<div class="py-3" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
  <span class="heading-regular">QR code</span>

  <mat-tab-group class="full-width">
    <mat-tab label="Form">
      <div class="fx-col-w-100 fx-v-center pt-3">
        <img [src]="qrCodeImageSrc" class="application-qr-code" alt="QR Code">
        <div class="fx-row fx-gap-10 fx-center fx-h-center">
          <button (click)="downloadQRCodeImage()" class="button-primary" style="width: 150px"
                  mat-button [disabled]="!qrCodeImageSrc">
            <div class="button-text">Download</div>
          </button>
          <button (click)="copyHostedFormLink()" mat-icon-button color="primary"
                  matTooltip="Copy link to clipboard">
            <mat-icon class="material-icons-outlined">content_copy</mat-icon>
          </button>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Custom">
      <div class="fx-col-w-100 fx-v-center pt-3 fx-gap-20">
        <div>Enter a custom URL for the QR code to open when it is scanned. This allows you to
          have prospective tenants land on a branded or custom page where the application for has been
          embedded instead of loading the application form directly in a web browser
        </div>

        <mat-form-field class="custom-text-field embed-input" appearance="outline">
          <input type="text" matInput [(ngModel)]="qrCodeUrl">
          <mat-icon matSuffix
                    matTooltip="Test link"
                    (click)="testExternalUrl()">
            link
          </mat-icon>
        </mat-form-field>
        <div class="fx-row-w-100 fx-h-center fx-v-center fx-gap-20">
          <button class="button-primary full-width" mat-button
                  (click)="updateQrCodeUrl()"
                  [disabled]="!canUpdateCustomUQrUrl">
            <div class="button-text">Update</div>
          </button>
          <button class="button-secondary full-width" mat-flat-button
                  (click)="removeCustomUrl()"
                  [disabled]="!qrCodeUrlFromContext">
            <div class="button-text">Remove</div>
          </button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
